import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
const PaymentsSubMenus = () => {
    const navigate = useNavigate();
    const { userData } = useSelector(
        (state) => state.user
    );
    let locationPathName  = (window.location.pathname).replace('/account','');
    return (
        <>
            <div className="top-tab-sec d-flex">
                <ul>
                    <li>
                        <Link to={`/payments`} className={
                            locationPathName === `/payments` || locationPathName === `/payments/`
                                ? "active"
                                : ""
                        }>Transactions</Link>
                    </li>
                    {
                        (
                            userData.role_slug === "super_admin" ||
                            userData.role_slug === "org_admin" ||
                            userData.role_slug === "finance_incharge" ||
                            userData.role_slug === "captain" ||
                            userData.caps_list.includes('fees_collection') ||
                            userData.caps_list.includes('fee_collection_transactions')
                        )
                        && <li>
                            <Link to={`/payments/lawazim-collection`} className={
                                locationPathName.includes(`/payments/lawazim-collection`) || locationPathName.includes(`/payments/lawazim-collection/`)
                                    ? "active"
                                    : ""
                            }>Lawazim Collections</Link>
                        </li>
                    }
                    {
                        (
                            userData.role_slug === "super_admin" ||
                            userData.role_slug === "org_admin" ||
                            userData.role_slug === "finance_incharge" ||
                            userData.role_slug === "captain" ||
                            userData.caps_list.includes('uniform_transactions'))
                        && <li>
                            <Link to={`/payments/uniform`} className={
                                locationPathName.includes(`/payments/uniform`) || locationPathName.includes(`/payments/uniform/`)
                                    ? "active"
                                    : ""
                            }>Uniform</Link>
                        </li>
                    }
                    {
                        (
                            userData.role_slug === "super_admin" ||
                            userData.role_slug === "org_admin" ||
                            userData.role_slug === "finance_incharge" ||
                            userData.role_slug === "captain" ||
                            userData.caps_list.includes('registration_transactions')
                        )
                        && <li>
                            <Link to={`/payments/registrations`} className={
                                locationPathName.includes(`/payments/registrations`) || locationPathName.includes(`/payments/registrations/`)
                                    ? "active"
                                    : ""
                            }>Registrations</Link>
                        </li>
                    }
                </ul>
                <select className="responsive-submenus select-input me-2" value={`${locationPathName}`} onChange={(e) => {
                    navigate(e.target.value);
                }}>
                    <option value={`/payments`}>Transactions</option>
                    {
                        (
                            userData.role_slug === "super_admin" ||
                            userData.role_slug === "org_admin" ||
                            userData.role_slug === "finance_incharge" ||
                            userData.role_slug === "captain" ||
                            userData.caps_list.includes('fees_collection') ||
                            userData.caps_list.includes('fee_collection_transactions')
                        )
                        && <option value={`/payments/lawazim-collection`}>Lawazim Collections</option>
                    }
                    {
                        (
                            userData.role_slug === "super_admin" ||
                            userData.role_slug === "org_admin" ||
                            userData.role_slug === "finance_incharge" ||
                            userData.role_slug === "captain" ||
                            userData.caps_list.includes('uniform_transactions')
                        )
                        && <option value={`/payments/uniform`}>Uniform</option>
                    }
                    {
                        (
                            userData.role_slug === "super_admin" ||
                            userData.role_slug === "org_admin" ||
                            userData.role_slug === "finance_incharge" ||
                            userData.role_slug === "captain" ||
                            userData.caps_list.includes('registration_transactions')
                        )
                        && <option value={`/payments/registrations`}>Registrations</option>
                    }
                </select>
            </div>
        </>
    )
}
export default PaymentsSubMenus;